import request from '@/utils/request'

export function getHotels() {
  return request({
    url: '/config-service/v1/agent/list',
    method: 'get'
  })
}

export function updateHotel() {

}

export function createHotel() {

}

export function deleteHotel() {

}

export function viewHotel() {

}

export function getAllHotels() {
  return request({
    url: '/config-service/v1/hotel/hotel/all',
    method: 'get'
  })
}
